// Shared locale utilities
import { getActiveLanguage } from '@haldor/ui';
import Moment from 'moment';
export var normalizeLocale = function normalizeLocale(lang) {
  if (!lang) return undefined;
  var l = String(lang).toLowerCase();
  var map = {
    'en-us': 'en',
    'en-gb': 'en-gb',
    'sv-se': 'sv',
    'sv': 'sv',
    'nb-no': 'nb',
    'nn-no': 'nn',
    'da-dk': 'da',
    'fi-fi': 'fi'
  };
  var normalized = map[l];
  if (!normalized) {
    var parts = l.split(/[-_]/);
    normalized = parts[0] || l;
  }

  // Try to set Moment locale for side effects (safe if locale not loaded)
  try {
    Moment.locale(normalized);
  } catch (e) {
    // ignore
  }
  return normalized;
};
export var getNormalizedActiveLanguage = function getNormalizedActiveLanguage() {
  return normalizeLocale(getActiveLanguage());
};

// Map normalized language to MUI X Date Pickers locale export
import * as pickersLocales from '@mui/x-date-pickers/locales';
export var getPickersLocale = function getPickersLocale(normalizedLang) {
  if (!normalizedLang) return null;
  var map = {
    en: 'enUS',
    'en-gb': 'enGB',
    sv: 'svSE',
    nb: 'nbNO',
    nn: 'nnNO',
    da: 'daDK',
    fi: 'fiFI'
  };
  var key = map[normalizedLang] || map[normalizedLang.split('-')[0]];
  if (!key) return null;
  return pickersLocales[key] || null;
};